import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import dayjs from "dayjs";
export var invPaymentInit = {
    dim_mst_withholding_tax_id: "",
    pay_date: dayjs().format("YYYY-MM-DD"),
    has_payment_rows: false,
    has_adjustment_or_fees: false,
    is_withholding_tax: false,
    factNewInvPaymentRow: [],
    factNewInvAdjustmentOrFee: []
};
export var invPaymentRowInit = {
    dim_branch_payment_channel_id: "",
    price: 0,
    remark: ""
};
export var invPaymentAdjustOrFeeInit = {
    dim_mst_adjust_or_fee_id: "",
    price: 0,
    remark: ""
};
export var setMappedInvPaymentToFormik = function(param) {
    var values = param.values, setFieldValue = param.setFieldValue;
    var mappingValue = values.factNewInvPayment.map(function(v) {
        return _object_spread_props(_object_spread({}, v), {
            fact_new_inv_payment_rows: v.factNewInvPaymentRow || [],
            fact_inv_adjustment_or_fees: v.factNewInvAdjustmentOrFee || []
        });
    });
    setFieldValue("fact_new_inv_payments", mappingValue);
    return mappingValue;
};
